export default __webpack_public_path__ + "static/media/ic-course (2).2f5ca55a.svg";